import {
  downloadScanPalletCartonLabel,
  getScanOrderPalletById,
} from "@/apis/tms/order";
import { useQuery } from "@tanstack/react-query";

export async function getScanOrderPallet(orderId?: string, palletId?: string) {
  if (orderId == null || palletId == null) return Promise.resolve(null);
  return getScanOrderPalletById(orderId, palletId);
}

export function useScanOrderPallet(orderId?: string, palletId?: string) {
  return useQuery({
    queryKey: ["scan-order-pallet", orderId, palletId],
    queryFn: () => getScanOrderPallet(orderId, palletId),
    staleTime: 0,
  });
}

export function useScanOrderPalletCartonLabel(
  orderId: string,
  palletId: string,
  scannedCartonId: number,
) {
  return useQuery({
    queryKey: [
      `order-${orderId}-pallet-${palletId}-carton-${scannedCartonId}-label`,
    ],
    queryFn: () =>
      downloadScanPalletCartonLabel(orderId, palletId, scannedCartonId),
  });
}
